export default function AppSection() {
  return (
    <section id="app" className="bg-background-100 section-padding">
      <div className="section-container">
        <div className="max-w-4xl mx-auto">
          <div className="bg-gradient-to-br from-primary-500 via-primary-600 to-accent-600 rounded-2xl p-6 md:p-10 flex flex-col lg:flex-row items-center gap-8 overflow-hidden relative">
            <div className="absolute top-0 right-0 w-64 h-64 rounded-full bg-background-50/10 blur-3xl translate-x-1/3 -translate-y-1/3"></div>
            <div className="absolute bottom-0 left-0 w-48 h-48 rounded-full bg-accent-400/15 blur-3xl -translate-x-1/3 translate-y-1/3"></div>

            <div className="flex-1 relative z-10 text-center lg:text-left">
              <span className="inline-block px-3 py-1 rounded-full bg-background-50/20 text-background-50 text-xs font-medium mb-4">
                移动端优化
              </span>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-3">
                移动观看
              </h2>
              <p className="text-sm text-background-50/80 leading-relaxed mb-6 max-w-md">
                青青草视频已针对移动端进行全面优化，在手机浏览器中即可流畅访问全部功能。高清适配、触屏交互、省流量模式，
                让您随时随地浏览影视平台资讯，发现优质观影入口。
              </p>
              <div className="flex items-center gap-4 justify-center lg:justify-start">
                <div className="flex items-center gap-2 px-5 py-2.5 rounded-lg bg-background-50 text-primary-700 font-medium text-sm cursor-pointer whitespace-nowrap">
                  <i className="ri-smartphone-line"></i>
                  手机浏览器访问
                </div>
                <div className="flex items-center gap-2 px-5 py-2.5 rounded-lg border border-background-50/30 text-background-50 font-medium text-sm cursor-pointer whitespace-nowrap">
                  <i className="ri-qr-code-line"></i>
                  扫码直达
                </div>
              </div>
            </div>

            <div className="relative z-10 flex-shrink-0">
              <div className="w-48 h-48 md:w-56 md:h-56 rounded-2xl bg-background-50/15 backdrop-blur border border-background-50/10 flex items-center justify-center">
                <div className="text-center">
                  <i className="ri-smartphone-line text-5xl text-background-50/60 mb-3 block"></i>
                  <span className="text-xs text-background-50/60">移动端适配</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}